module.exports = __webpack_public_path__ + "img/caselogo.b7f89ef5.png";